import env from '~/src/utils/env';
import { FALLBACK_REGION } from '~/src/utils/constants';

export enum Region {
  US = 'us',
  EU = 'eu',
  AU = 'au',
  CA = 'ca',
}

export const getRegion = (): Region => {
  return (env.reactAppRegion || FALLBACK_REGION).toLowerCase() as Region;
};
